module.exports = __webpack_public_path__ + "static/media/banner-eclos-voucher__catalog.79a35b6d.png";